export { mixpanelPlugin } from "./mixpanel";
export type { MixpanelPluginMethods, MixpanelPluginOptions } from "./mixpanel";
